import { render, staticRenderFns } from "./StatsPage.vue?vue&type=template&id=3af73139&scoped=true"
import script from "./StatsPage.vue?vue&type=script&lang=js"
export * from "./StatsPage.vue?vue&type=script&lang=js"
import style0 from "./StatsPage.vue?vue&type=style&index=0&id=3af73139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af73139",
  null
  
)

export default component.exports